import type { AvatarState } from '@/types/andrzej'

interface Props {
  avatarState: AvatarState
  onNewConversation: () => void
  onToggleConversations: () => void
  onClose?: () => void
}

const AVATAR_IMAGES: Record<AvatarState, string> = {
  default: '/andrzej/andrzej-default.svg',
  thinking: '/andrzej/andrzej-thinking.svg',
  writing: '/andrzej/andrzej-writing.svg',
  happy: '/andrzej/andrzej-happy.svg',
  concerned: '/andrzej/andrzej-concerned.svg',
}

export function AndrzejHeader({ avatarState, onNewConversation, onToggleConversations, onClose }: Props) {
  return (
    <div className="flex items-center gap-sm border-b border-desk px-md py-sm bg-paper-dark">
      <img
        src={AVATAR_IMAGES[avatarState]}
        alt="Andrzej"
        className="h-[3.2rem] w-[3.2rem] rounded-full object-cover shrink-0"
        key={avatarState}
      />
      <div className="flex-1 min-w-0">
        <div className="font-display text-[0.9rem] text-ink">Andrzej</div>
        <div className="text-[0.65rem] text-frame italic">Twój ogrodnik</div>
      </div>
      <div className="flex items-center gap-0.5">
        <button
          onClick={onNewConversation}
          className="flex items-center justify-center w-[2.2rem] h-[2.2rem] rounded text-frame hover:text-ink hover:bg-paper cursor-pointer border-none bg-transparent transition-colors"
          title="Nowa rozmowa"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </button>
        <button
          onClick={onToggleConversations}
          className="flex items-center justify-center w-[2.2rem] h-[2.2rem] rounded text-frame hover:text-ink hover:bg-paper cursor-pointer border-none bg-transparent transition-colors"
          title="Historia rozmów"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/>
          </svg>
        </button>
        {onClose && (
          <button
            onClick={onClose}
            className="hidden max-sm:flex items-center justify-center w-[2.2rem] h-[2.2rem] rounded text-frame hover:text-ink hover:bg-paper cursor-pointer border-none bg-transparent transition-colors"
            title="Zwiń Andrzeja"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>
        )}
      </div>
    </div>
  )
}
